import React from 'react';
import { ArrowLeft } from 'lucide-react';

const MobileHeader = ({ navigate }) => {
  return (
    <div className="wp-mobile-header">
      <button className="wp-mobile-header__back" onClick={() => navigate(-1)}>
        <ArrowLeft size={22} />
      </button>
      <h2 className="wp-mobile-header__title">Profile</h2>
    </div>
  );
};

export default MobileHeader;